import React, { useEffect } from 'react';
import './RedirectPage.css';

/**
 * 微信浏览器跳转中间页
 * 检测到在微信内置浏览器中时，显示此页面引导用户使用浏览器打开
 */
const RedirectPage = () => {
  useEffect(() => {
    // 检测是否在微信内置浏览器中
    const isWeChat = /micromessenger/i.test(navigator.userAgent);

    if (!isWeChat) {
      // 如果不是微信浏览器，重定向到首页
      window.location.href = '/';
    }
  }, []);

  return (
    <div className="redirect-page">
      <div className="redirect-content">
        <div className="redirect-icon">🌐</div>
        <h1 className="redirect-title">请在浏览器中打开</h1>
        <p className="redirect-desc">
          为了更好的体验，请在浏览器中使用本应用
        </p>
        <div className="redirect-steps">
          <div className="step-item">
            <span className="step-number">1</span>
            <span className="step-text">点击右上角 <span className="dots-icon">···</span></span>
          </div>
          <div className="step-item">
            <span className="step-number">2</span>
            <span className="step-text">选择"在浏览器打开"</span>
          </div>
        </div>
        <div className="redirect-illustration">
          <svg viewBox="0 0 200 160" className="arrow-illustration">
            <rect x="10" y="20" width="60" height="80" rx="5" fill="#667eea" opacity="0.2"/>
            <circle cx="25" cy="50" r="4" fill="#667eea"/>
            <circle cx="40" cy="50" r="4" fill="#667eea"/>
            <circle cx="55" cy="50" r="4" fill="#667eea"/>
            <polygon points="150,30 170,30 160,50" fill="#764ba2"/>
            <polygon points="150,30 140,45 160,45" fill="#667eea"/>
            <path d="M 160 45 Q 120 60 80 70" stroke="#667eea" strokeWidth="3" fill="none" strokeDasharray="5,5"/>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default RedirectPage;
